import _ from 'lodash';
import { DEFAULT_SCORE_LIMIT } from 'common/constants';
import { CardFacadeBase } from 'utils/facades/card-facade-base';

class NavigationFacade extends CardFacadeBase {
	getNextCardId = ({ totalScore }): string => {
		const byScore = ({ score }) => {
			if (!score) {
				return false;
			}
			const min = score[0] || DEFAULT_SCORE_LIMIT.MIN;
			const max = Number.isInteger(score[1]) ? score[1] + 1 : Infinity;
			return _.inRange(totalScore, min, max);
		};

		if (!this.data) {
			return '';
		}

		const event = _.find(this.data.events, byScore);
		return _.get(event, 'connection.pointId') || '';
	};
}

export { NavigationFacade };
